import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { CONSTANTS } from 'services/constants';
import { ThemeContext } from 'utils/context';
import DatePicker from '../DatePicker';
import InputLabel from '../InputLabel';

function EditableDatePicker({
    containerClassName,
    disableLabel,
    editing,
    inputProps,
    labelText,
    labelProps,
    text,
})
{
    const {
        darkMode,
    } = useContext(ThemeContext);

    return (
        editing ? (
            <div className={containerClassName}>
                { !disableLabel
                    && (
                        <label className={`tw-font-bold tw-mb-3 ${labelProps.className}`}>{labelText}</label>
                    )}
                <DatePicker
                    calendarClassName={`${darkMode ? 'react-datepicker__dark' : ''}`}
                    containerClassName="tw-w-full"
                    dateFormat={inputProps.dateFormat}
                    onChange={inputProps.onChange}
                    path={inputProps.path}
                    value={inputProps.value}
                    style={inputProps.style}
                    errorClassName={inputProps.errorClassName}
                    error={inputProps.error}
                    printErrors={inputProps.printErrors}
                    peekNextMonth={inputProps.peekNextMonth}
                    showMonthDropdown={inputProps.showMonthDropdown}
                    showYearDropdown={inputProps.showYearDropdown}
                    maxDate={inputProps.maxDate}
                    placeholder={inputProps.placeholder}
                    disabled={inputProps.disabled}
                />
            </div>
        ) : (
            <div className={`tw-flex tw-flex-row ${containerClassName}`}>
                <InputLabel label={labelText} text={text} />
            </div>
        )
    );
}

EditableDatePicker.defaultProps = {
    containerClassName: '',
    labelProps: {},
    text: '',
};

EditableDatePicker.propTypes = {
    containerClassName: PropTypes.string,
    disableLabel: PropTypes.bool,
    editing: PropTypes.bool.isRequired,
    inputProps: PropTypes.shape({
        dateFormat: PropTypes.oneOf(Object.values(CONSTANTS.FORMATS)),
        errorClassName: PropTypes.string,
        peekNextMonth: PropTypes.bool,
        showMonthDropdown: PropTypes.bool,
        showYearDropdown: PropTypes.bool,
        error: PropTypes.node,
        onChange: PropTypes.func,
        path: PropTypes.string,
        printErrors: PropTypes.bool,
        style: PropTypes.object,
        value: PropTypes.string,
        placeholder: PropTypes.string,
        maxDate: PropTypes.any,
        disabled: PropTypes.bool,
    }),
    labelProps: PropTypes.object,
    labelText: PropTypes.string.isRequired,
    text: PropTypes.node,
};

export default EditableDatePicker;
